// GarsonEkrani.js
// Konum: src/GarsonEkrani.js — Route: /garson/:restaurantId/:waiterId

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const BACKEND = process.env.REACT_APP_API_URL;

export default function GarsonEkrani() {
  const { restaurantId, waiterId } = useParams();
  const [calls, setCalls] = useState([]);
  const [expiredCalls, setExpiredCalls] = useState([]);
  const [acking, setAcking] = useState(null);
  const [clearing, setClearing] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const fetchCalls = async () => {
      try {
        const res = await fetch(`${BACKEND}/call-waiter/call/active/${restaurantId}`);
        setCalls(await res.json());
      } catch (err) {
        console.error('Çağrılar çekilemedi:', err);
      }
    };

    fetchCalls();
    const interval = setInterval(fetchCalls, 2000);
    return () => clearInterval(interval);
  }, [restaurantId]);

  // Süresi dolan (unutulan) çağrıları da ayrıca çekiyoruz
  useEffect(() => {
    const fetchExpired = async () => {
      try {
        const res = await fetch(`${BACKEND}/call-waiter/call/expired/${restaurantId}`);
        setExpiredCalls(await res.json());
      } catch (err) {
        console.error('Süresi dolan çağrılar çekilemedi:', err);
      }
    };

    fetchExpired();
    const interval = setInterval(fetchExpired, 3000);
    return () => clearInterval(interval);
  }, [restaurantId]);

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const onayla = async (callId) => {
    setAcking(callId);
    try {
      await fetch(`${BACKEND}/call-waiter/call/acknowledge`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ callId, restaurantId, waiterId }),
      });
      setCalls((prev) => prev.filter((c) => c.id !== callId));
    } catch (err) {
      console.error('Onaylanamadı:', err);
    } finally {
      setAcking(null);
    }
  };

  // Garson "Hallettim" dediğinde süresi dolan çağrıyı listeden kalıcı olarak siler
  const hallettim = async (callId) => {
    setClearing(callId);
    try {
      await fetch(`${BACKEND}/call-waiter/call/${restaurantId}/${callId}`, {
        method: 'DELETE',
      });
      setExpiredCalls((prev) => prev.filter((c) => c.id !== callId));
    } catch (err) {
      console.error('Silinemedi:', err);
    } finally {
      setClearing(null);
    }
  };

  const saniyeOnce = (createdAt) => Math.floor((now - createdAt) / 1000);
  const dakikaOnce = (createdAt) => Math.floor((now - createdAt) / 60000);

  return (
    <div className="min-h-screen bg-gray-900 pb-6">
      <div className="sticky top-0 bg-gray-900 z-10 flex items-center justify-between px-5 py-5">
        <span className="text-white font-bold text-xl">Bekleyen Çağrılar</span>
        <span className="bg-orange-500 text-white min-w-[28px] h-7 rounded-full flex items-center justify-center text-sm font-bold px-2">
          {calls.length}
        </span>
      </div>

      {calls.length === 0 ? (
        <div className="flex flex-col items-center justify-center gap-3 py-24 text-slate-500">
          <div className="w-14 h-14 rounded-full bg-green-400/10 text-green-400 flex items-center justify-center text-2xl font-bold">✓</div>
          <span>Şu an bekleyen çağrı yok</span>
        </div>
      ) : (
        <div className="flex flex-col gap-2.5 px-4">
          {calls.map((call) => (
            <div key={call.id} className="flex items-center justify-between bg-slate-800 border border-slate-700 rounded-2xl px-5 py-4">
              <div>
                <div className="text-white font-bold text-xl">Masa {call.tableNumber}</div>
                <div className="text-orange-400 text-xs font-semibold mt-1">{saniyeOnce(call.createdAt)} sn önce</div>
              </div>
              <button
                onClick={() => onayla(call.id)}
                disabled={acking === call.id}
                className="bg-green-400 text-gray-900 rounded-xl px-6 py-3.5 font-bold text-base disabled:opacity-60 active:scale-95 transition-transform"
              >
                {acking === call.id ? '...' : 'Geldim'}
              </button>
            </div>
          ))}
        </div>
      )}

      {expiredCalls.length > 0 && (
        <div className="mt-8 px-4">
          <div className="flex items-center gap-2 mb-3 px-1">
            <span className="text-red-400 font-bold text-base">⚠️ Süresi Dolan Çağrılar</span>
            <span className="bg-red-500/20 text-red-400 min-w-[24px] h-6 rounded-full flex items-center justify-center text-xs font-bold px-2">
              {expiredCalls.length}
            </span>
          </div>
          <p className="text-slate-500 text-xs mb-3 px-1">
            Bu çağrılar 40 saniye içinde onaylanmadı. İlgilendiysen "Hallettim" ile listeden kaldır.
          </p>
          <div className="flex flex-col gap-2.5">
            {expiredCalls.map((call) => (
              <div key={call.id} className="flex items-center justify-between bg-red-950/40 border border-red-900/50 rounded-2xl px-5 py-4">
                <div>
                  <div className="text-white font-bold text-xl">Masa {call.tableNumber}</div>
                  <div className="text-red-400 text-xs font-semibold mt-1">{dakikaOnce(call.createdAt)} dk önce çağırmıştı</div>
                </div>
                <button
                  onClick={() => hallettim(call.id)}
                  disabled={clearing === call.id}
                  className="bg-slate-700 text-white rounded-xl px-5 py-3.5 font-bold text-sm disabled:opacity-60 active:scale-95 transition-transform"
                >
                  {clearing === call.id ? '...' : 'Hallettim'}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}